module.exports = __webpack_public_path__ + "static/img/13.c41e931.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/13.png
// module id = ewgQ
// module chunks = 1